import React from 'react';
export function InfrastructureStrip() {
  return <section className="w-full py-20 md:py-24 relative font-heading border-y border-white/[0.05]" style={{
    backgroundColor: '#09090B'
  }} data-id="element-514">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-515">
        <div className="text-center mb-16" data-id="element-516">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-517">
            Construit pour la fiabilité qu'une marque mondiale exige
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-518">
          {/* Column 1 */}
          <div className="space-y-4" data-id="element-519">
            <div className="w-12 h-12 rounded-xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center mb-6" data-id="element-520">
              <div className="w-5 h-5 rounded bg-blue-400/50" data-id="element-521" />
            </div>
            <h3 className="text-xl font-semibold text-white" data-id="element-522">
              Hébergement & Sécurité
            </h3>
            <p className="text-white/60 leading-relaxed" data-id="element-523">
              Déploiement edge mondial, CDN Cloudflare, protection DDoS,
              stockage médias en Europe, monitoring temps réel.
            </p>
          </div>

          {/* Column 2 */}
          <div className="space-y-4" data-id="element-524">
            <div className="w-12 h-12 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center mb-6" data-id="element-525">
              <div className="w-5 h-5 rounded-full bg-cyan-400/50" data-id="element-526" />
            </div>
            <h3 className="text-xl font-semibold text-white" data-id="element-527">Architecture</h3>
            <p className="text-white/60 leading-relaxed" data-id="element-528">
              React Progressive Web App, API GraphQL (efficace, flexible,
              auto-documentée), stockage objet scalable.
            </p>
          </div>

          {/* Column 3 */}
          <div className="space-y-4" data-id="element-529">
            <div className="w-12 h-12 rounded-xl bg-purple-500/10 border border-purple-500/20 flex items-center justify-center mb-6" data-id="element-530">
              <div className="w-5 h-5 bg-purple-400/50" style={{
              clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)'
            }} data-id="element-531" />
            </div>
            <h3 className="text-xl font-semibold text-white" data-id="element-532">Localisation</h3>
            <p className="text-white/60 leading-relaxed" data-id="element-533">
              6 langues (FR, EN, ES, PT, IT, 中文), scheduling timezone-aware
              sur tous les modules, entièrement white-label.
            </p>
          </div>
        </div>
      </div>
    </section>;
}